import { get, post } from '@/utils/request'

const userApi = {
  userPersonal: '/api/user/personal',
  userInfoApi: '/api/user/info',
  updateProfileApi: '/api/user/signature',
  discoverUserApi: '/api/user/discover',
  followUserApi: '/api/user/relation/follow',
  unfollowUserApi: '/api/user/relation/unfollow',
  checkRelationApi: '/api/user/relation/check',
  userFollowerApi: '/api/user/relation/follower',
  userFollowingApi: '/api/user/relation/following',
  userContactApi: '/api/user/contact/list',
  searchUserApi: '/api/user/search',
  userMessageApi: '/api/message/user',
  walletApi: '/api/user/wallet',
  walletBillApi: '/api/user/wallet/bill',
  approvalApi: '/api/user/approval',
  adminApprovalApi: '/api/admin/user/approval'
}

export function getUserInfo(userId) {
  return get(userApi.userInfoApi + '?userId=' + userId)
}

export function updateUserSignature(jsonData) {
  return post(userApi.updateProfileApi, jsonData)
}

export function getUsers() {
  return get(userApi.discoverUserApi)
}

// 关注用户
export function followUser(followingId) {
  return post(userApi.followUserApi + '/' + followingId)
}

// 取消关注用户
export function unfollowUser(followingId) {
  return post(userApi.unfollowUserApi + '/' + followingId)
}

export function checkRelation(userId) {
  return get(userApi.checkRelationApi + '/' + userId)
}

export function getUserFollower(userId) {
  return get(userApi.userFollowerApi + '/' + userId)
}

export function getUserFollowing(userId) {
  return get(userApi.userFollowingApi + '/' + userId)
}

export function getUserContact(pn) {
  return get(userApi.userContactApi + '?pn=' + pn)
}

export function searchUser(queryForm) {
  return get(userApi.searchUserApi, queryForm)
}

export function getUnreadCount() {
  return get(userApi.userMessageApi + '/unread')
}

export function getUnreadMessages(queryParams) {
  return get(userApi.userMessageApi + '/unread/list', queryParams)
}

export function getMessageDetail(queryParams) {
  return get(userApi.userMessageApi + '/detail', queryParams)
}

export function clearMessages() {
  return post(userApi.userMessageApi + '/unread/clear')
}

export function getWallet() {
  return get(userApi.walletApi)
}

export function getWalletBill() {
  return get(userApi.walletBillApi)
}

export function addApprovalRequest(payload) {
  return post(userApi.approvalApi + '/add', payload)
}

export function getUserApprovalRequests(queryParams) {
  return get(userApi.approvalApi + '/user_list', queryParams)
}

export function auditApprovalRequest(payload) {
  return post(userApi.adminApprovalApi + '/audit', payload)
}

export function getApprovalRequests(queryParams) {
  return get(userApi.adminApprovalApi + '/admin_list', queryParams)
}

export function addPersonalData(payload) {
  return post(userApi.userPersonal, payload)
}

export function getPersonalData() {
  return get(userApi.userPersonal)
}
